import { h } from 'preact'; /** @jsx h */

import BannerImage from '../components/torarne/BannerImage/BannerImage';
import CTABlock from '../components/torarne/CTABlock/CTABlock';
import Content from '../components/torarne/Content/Content';
import Divider from '../components/torarne/Divider/Divider';
import FactPopup from '../components/torarne/FactPopup/FactPopup';
import FooterCTA from '../components/torarne/FooterCTA/FooterCTA';
import Heading from '../components/torarne/Heading/Heading';
import Hero from '../components/torarne/Hero/Hero';
import Image from '../components/torarne/Image/Image';
import Paragraph from '../components/torarne/Paragraph/Paragraph';
import Quote from '../components/torarne/Quote/Quote';
import Section from '../components/torarne/Section/Section';
import SplitCTABox from '../components/torarne/SplitCTABox/SplitCTABox';
import Video from '../components/torarne/Video/Video';
import VippsBanner from '../components/torarne/VippsBanner/VippsBanner';

import StickyCTA from '../components/torarne/StickyCTA/StickyCTA';
import '../styles/torarne/nektet-a-gi-opp.scss';

const TorArne = () => {
    return (
        <div className="torarne">
            <div className="gutters">
                <Hero
                    imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/12/torarne-1-tall.jpg"
                    alt="Tor Arne ligger i en sykeseng med mye medisinsk utstyr rundt seg"
                >
                    <div className="sticky-tag-wrapper">
                        <div className="sticky-tag-container">
                            <a className="sticky-tag" href="/kampanje/jul" target="_blank">
                                Ingen å miste.
                            </a>
                        </div>
                    </div>
                    <div className="emergency-stripes">
                        <img
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/02/akuttstriper-vertikal-gul.svg"
                            alt="Gule akuttstriper"
                            loading="lazy"
                        />
                    </div>
                    <div className="above-fold">
                        <Heading type="h1" className="hero-title">
                            <span className="hero-title-section">
                                <span>
                                    <i>«Han må ikke dø!»</i>
                                </span>
                            </span>
                        </Heading>
                    </div>
                    <div className="hero-overlay">
                        <div className="overlay-padding">
                            <Content width="small">
                                <Paragraph type="ingress" color="all-white">
                                    Tor-Arne sitter i ambulansen mens ambulansepersonellet klargjør
                                    bilen for å ta han med til legevakten. Han har brystsmerter og
                                    vet at noe er galt. Plutselig blir Tor-Arne svimmel. Han rekker
                                    så vidt å si i fra før han faller om – med hjertestans.
                                </Paragraph>
                                <Paragraph
                                    type="byline"
                                    textAndPhoto="Karoline Lervik Sandvold"
                                    video="Kim Aage Leinhardt"
                                    color="all-white"
                                />
                                <Paragraph color="all-white">
                                    Det er en flott solrik vinterdag i januar. Trærne glitrer i
                                    sola. Det er godt med nysnø. En perfekt dag for å gå på
                                    langrenn, så Beate Strand (58) og yngste sønnen Jacob bestemmer
                                    seg for å ta seg en skitur med hennes bror og hans barn.
                                </Paragraph>
                                <Paragraph color="all-white">
                                    Ektemannen, Tor-Arne Strand beveger seg sjeldent utendørs om det
                                    ikke er noe praktisk arbeid som skal gjøres, så han blir hjemme
                                    og jobber med snøskuteren. Batteriet må byttes og det er noe
                                    annet vedlikehold som må utføres.
                                </Paragraph>
                                <Paragraph color="all-white">
                                    Etter å ha gjort seg ferdig, prøvekjører Tor-Arne snøskuteren.
                                    Underveis får han plutselig smerter i brystet. Det skal mye til
                                    før Tor-Arne ber om hjelp, men det er noe som gjør at han ringer
                                    116117 til legevakten denne dagen. Noe er galt. Magefølelsen
                                    sier at dette er alvorlig.
                                </Paragraph>
                                <Paragraph color="all-white">
                                    Legevakten sender en ambulanse. Den er kun fem minutter unna, så
                                    de kommer raskt frem. Ambulansepersonellet tar EKG og det blir
                                    tatt ulike tester.
                                </Paragraph>
                                <Quote animation="fade-up" color="all-white" borderColor="red">
                                    – De klarte ikke fastslå hjerteinfarkt eller direkte årsak til
                                    smertene. De bestemte seg for å ta meg med inn til legevakten
                                    for å gjøre videre undersøkelser der, forteller Tor-Arne.
                                </Quote>
                                <Paragraph color="all-white">
                                    Han forsøker å ringe kona, Beate, for å si ifra. Hun tar ikke
                                    telefonen.
                                </Paragraph>
                            </Content>
                        </div>
                    </div>
                </Hero>

                <BannerImage
                    imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/12/torarne-4.jpg"
                    alt="Tor Arne og kona Beate ute på tur på grusveien rundt jordet"
                    contentPlacement="bottom"
                >
                    <Content width="small">
                        <Paragraph></Paragraph>
                        <Heading type="h3" weight="600" color="all-black">
                            Fortet seg ned fjellet
                        </Heading>
                        <Paragraph color="all-black">
                            <b>
                                Beate hører ikke telefonen ringe når hun går på ski. Det er ikke før
                                de setter seg ned rundt bålet at hun ser meldingen fra Tor-Arne. Hun
                                kjenner på frykten over hva som har skjedd.
                            </b>
                        </Paragraph>
                    </Content>
                </BannerImage>

                <Section color="off-white">
                    <StickyCTA
                        link="/nettbutikk/symbolske-gaver/et-hjerte-som-banker-igjen/"
                        title="Støtt vår hjerteforskning"
                        text="Et hjerte som banker igjen"
                        buttonCaption="Motta gavebevis som takk"
                        buttonText="Kjøp symbolsk gave"
                        orientation="left"
                        target="_blank"
                    />
                    <Content width="small">
                        <Paragraph>
                            Beate ringer tilbake og får umiddelbart svar fra mannen sin. Han
                            forteller at ambulansen akkurat har kommet. Beate sier at hun skal forte
                            seg ned slik at hun kan bli med Tor-Arne, om han må til sykehuset i
                            Bodø.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – Jeg har aldri gått så fort på ski før. Jeg hadde kun én tanke i hodet,
                            og det var at jeg måtte rekke frem for å være hos Tor-Arne.
                        </Quote>
                        <Paragraph>
                            Når de kjører inn mot hjemmet deres ser de ambulansen stå parkert
                            utenfor. Beate går ut av bilen, men stopper raskt opp. Sidedøra på
                            ambulansen er åpen. En fot stikker ut. Tor-Arne sin fot.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – Det er et bilde som sitter fast i minnet. Da skjønte jeg at dette her
                            er alvorlig. Noe er veldig galt, sier hun.
                        </Quote>
                        <Paragraph>
                            Kun noen minutter tidligere sitter Tor-Arne i ambulansen mens
                            ambulansepersonellet klargjør bilen for å ta han med til legevakten.
                            Plutselig blir Tor-Arne svimmel. Han rekker så vidt å si i fra før han
                            faller om – med hjertestans.
                        </Paragraph>
                        <Heading type="h3" weight="600" color="all-black">
                            <i>«Han må ikke dø!»</i>
                        </Heading>
                        <Paragraph></Paragraph>
                        <Video
                            src="https://player.vimeo.com/video/1035887705?autoplay=0&autopause=0&muted=0&loop=0&title=0&byline=0&portrait=0"
                            padding="56.25%"
                            height="380"
                            caption="<b>Redsel for å bli alene:</b> Beate forteller om da hun fikk beskjeden om at Tor-Arne hadde fått hjertestans."
                        />
                        <Paragraph>
                            Når hjertet til Tor-Arne stopper, begynner apparatet å gå.
                            Luftambulansen blir umiddelbart tilkalt. Ambulansepersonellet får dratt
                            Tor-Arne ned fra stolen og på gulvet.
                        </Paragraph>
                        <Paragraph>
                            Ambulansepersonellet jobber iherdig med Tor-Arne, og prøver samtidig
                            etter beste evne å skjerme det for Beate. De vil ikke at hun skal se
                            hvor dramatisk det faktisk er.
                        </Paragraph>
                        <Paragraph>
                            Jakob hjelper ambulansepersonellet med blant annet å løfte pappaen sin
                            fra gulvet og opp på båra.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – Jeg husker jeg satt på kne i snøen og var veldig fortvilet og lurte på
                            hvor i alle dager denne luftambulansen ble av. Jeg syntes det tok veldig
                            lang tid. Så det var en stor lettelse når jeg hørte lyden fra
                            helikopteret, at det var i nærheten, forteller Beate.
                        </Quote>
                        <Paragraph>
                            Fortsatt sittende på kne i snøen forteller hun med fortvilet stemme til
                            luftambulanselegen:
                        </Paragraph>
                        <Video
                            src="https://player.vimeo.com/video/1035887772?autoplay=0&autopause=0&muted=0&loop=0&title=0&byline=0&portrait=0"
                            padding="56.25%"
                            height="380"
                            caption="<b>«Det er ikke godt nok»:</b> Beate forteller at den strenge beskjeden hun ga til luftambulanselegen bidro til at han nektet å gi opp Tor-Arne."
                        />
                        <Paragraph></Paragraph>
                        <Heading type="h3" weight="600" color="all-black">
                            Bra at det var kaldt
                        </Heading>
                        <Paragraph>
                            Luftambulanselegen bestemmer at de skal bruke{' '}
                            <FactPopup
                                factTitle="LUCAS"
                                factText="LUCAS brystkompresjonssystem er et bærbart verktøy utformet for å løse problemer i forbindelse med manuell brystkompresjon. LUCAS bistår redningspersonell ved å gi effektiv, konsekvent og kontinuerlig brystkompresjon."
                            >
                                LUCAS
                            </FactPopup>
                            på Tor-Arne for å frigjøre hendene sine. Alt dette skjer ute på
                            gårdsplassen, i minusgrader.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – Jeg synes så synd på Tor-Arne som lå på båra og frøs. Det synes jeg
                            var kjempetrasig. Men helsepersonellet sa at «du skal være glad det er
                            kaldt. Det gjør det bedre for oss. Han har mye større odds nå, så det
                            går fint at han er litt kald».
                        </Quote>
                        <Paragraph>
                            Hele veien oppdaterer helsepersonellet Beate om hva som skjer. De
                            forklarer at han er ustabil, og at det er vanskelig å stabilisere han.
                            Men de har ikke gitt opp, de skal fortsette å gjøre alt de kan.
                        </Paragraph>
                        <Paragraph>
                            De bruker hjertestarteren 14 ganger på Tor-Arne for å prøve å
                            stabilisere ham. Legen ser en liten bevegelse i hjertet på ultralyden.
                            Det er nok til at han ikke kan gi opp Tor-Arne.
                        </Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – 14 støt med hjertestarteren er for meg et enormt tall. Og det viser
                            noe om hvor ustabil han var. Det var utrolig skremmende, for jeg har
                            aldri hørt om at det er mulig å bruke hjertestarter på noen så mange
                            ganger. På film ser man at de kanskje bruker den tre ganger på noen, og
                            så erklærer de at personen ikke lever lenger, sier Beate.
                        </Quote>
                        <Paragraph>
                            Luftambulanselegen fulgte hele tiden med på hjertet hans, med
                            ultralydmaskinen.
                        </Paragraph>
                        <Paragraph>Hun legger til:</Paragraph>
                        <Quote animation="fade-up" borderColor="primary">
                            – Tor-Arne har en ukuelig livsvilje. Han gir ikke opp. Han kjempet som
                            en helt for å klare det her.
                        </Quote>
                    </Content>
                    <FooterCTA
                        href="/nettbutikk/symbolske-gaver/et-hjerte-som-banker-igjen/"
                        linkText="<b>Et hjerte som banker igjen</b><br/>Kjøp den symbolske gaven her"
                        color="red"
                        bgColor="off-white"
                        textColor="all-white"
                        target="_blank"
                    />
                </Section>
                <Section color="secondary" borderRadius="top">
                    <BannerImage
                        imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/12/torarne-6-1.jpg"
                        alt="Dronebilde av tomten til Tor Arne og Beate, med rød markering på jordet der Tor Arne Strand ble hentet av luftambulansen"
                        caption="<b>Landingsplass ved vannet:</b> Her landet luftambulansen. Huset lengst fra veien var Beate og Tor-Arne sitt."
                        spaceY={true}
                        splitOnMobile
                    />
                </Section>
                <Section color="secondary" borderRadius="bottom">
                    <div className="emergency-stripes">
                        <img
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/02/akuttstriper-vertikal-gul.svg"
                            alt="Gule akuttstriper"
                        />
                    </div>
                    <StickyCTA
                        link="/nettbutikk/symbolske-gaver/et-hjerte-som-banker-igjen/"
                        title="Støtt vår hjerteforskning"
                        text="Et hjerte som banker igjen"
                        buttonCaption="Motta gavebevis som takk"
                        buttonText="Kjøp symbolsk gave"
                        orientation="right"
                        target="_blank"
                        spaceY
                    />
                    <Content width="small" spaceY spaceX>
                        <Paragraph color="all-white" className="no-margin">
                            Tor-Arne blir kjørt i ambulansen ned til helikopteret. På veien blir han
                            ustabil igjen. De bruker lang tid for å komme seg i helikopteret som
                            skal fly til Tromsø.
                        </Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Jeg skjønte at dette var kritisk. Legen sa: «Vi flyr. Vi tar sjansen,
                            men vi vet ikke hvordan det går. Så du er nødt til å være forberedt på
                            at vi kanskje må jobbe. Da må vi lande på en fjelltopp eller en mark, og
                            da må du ut.»
                        </Quote>
                        <Paragraph color="all-white">
                            For Beate var det viktigste å få være med – uansett hva som kom til å
                            skje. Om det skulle gå galt ville hun være der med han.
                        </Paragraph>
                        <Heading type="h3" weight="600" color="all-white">
                            Ga trombolyse i helikopteret
                        </Heading>
                        <Paragraph color="all-white">
                            Under flyturen til sykehuset vet Beate at mannen hennes er i de beste
                            hender. Mannskapet i helikopteret er rolige. De har kontroll.
                        </Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Det var ingen dramatikk som gjorde at jeg følte at dette var skummelt.
                            Jeg tror nok jeg skjønte hvor alvorlig det var, men det som hendte rundt
                            han var så rolig og profesjonelt, og samtidig så menneskelig.
                        </Quote>
                        <Paragraph color="all-white">
                            Luftambulanselegen bestemmer seg for å sette{' '}
                            <FactPopup
                                factTitle="Trombolyse"
                                factText="Trombolyse er en medisinsk betegnelse for nedbrytning av blodpropper (tromber) ved hjelp av legemidler. Trombolytisk behandling gis som oftest intravenøst."
                            >
                                trombolyse
                            </FactPopup>{' '}
                            for å se om det kan bidra til å løse opp en eventuell blodpropp. Nå har
                            det gått så lang tid at det ikke er noe å tape på å forsøke. Heldigvis
                            blir Tor-Arne mer stabil.
                        </Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Jeg tenkte: «For en lege. Igjen! Som prøver, han gir ikke opp.»,
                            smiler Beate.
                        </Quote>
                        <Paragraph color="all-white">
                            Rett før de lander får de en målbar puls. Der står det et stort team,
                            klare for å ta imot Tor-Arne. De får han over på en båre og forsvinner
                            inn på sykehuset.
                        </Paragraph>
                        <Image
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/12/torarne-7.jpg"
                            alt="Utviklingshelikopteret flyr over et vinterlandskap."
                            caption="<b>Utviklingshelikopter:</b> Luftambulansen har et eget helikopter som brukes til å teste ut nye løsninger og metoder for å kunne redde flere liv."
                            captionColor="all-white"
                        />
                        <Paragraph></Paragraph>
                        <Heading type="h3" weight="600" color="all-white">
                            Får til sammen 18 støt
                        </Heading>
                        <Paragraph color="all-white">
                            ECMO-teamet begynner å gjøre undersøkelser for å se på blodårene hans,
                            men før de kommer så langt må de bruke hjertestarteren to ganger på
                            grunn av hjerteflimmer.
                        </Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Da fikk de meg såpass stabil, og fikk gått inn og funnet en blodåre
                            som var tett. Den fikk de løsnet opp, forteller Tor-Arne.
                        </Quote>
                        <Paragraph color="all-white">
                            Når de var ferdige, fikk han et nytt hjerteflimmer. Igjen brukte de
                            hjertestarteren to ganger for å stabilisere. Nå har Tor-Arne til sammen
                            fått 18 støt fra han fikk hjertestans.
                        </Paragraph>
                        <Paragraph color="all-white">
                            Han blir deretter koblet til{' '}
                            <FactPopup
                                factTitle="ECMO"
                                factText="ECMO-behandling foregår ved hjelp av en modifisert hjerte-lungemaskin som via plastslanger kobles til store blodårer i kroppen. Maskinen kan brukes til å avlaste et sviktende hjerte og/eller lunger både hos voksne og barn. Kilde: Oslo universitetssykehus."
                            >
                                ECMO
                            </FactPopup>
                            . Da er det maskinen som tar over jobben for hjertet og lungene.
                        </Paragraph>
                        <Heading type="h3" weight="600" color="all-white">
                            <i>«Jeg er så glad i dere»</i>
                        </Heading>
                        <Paragraph color="all-white">
                            Tor-Arne er koblet til ECMO i fire dager før de kobler den fra. Dagen
                            etter vekker de han. Det første som møter han, er Beate og den eldste
                            sønnen deres. De står ved fotenden når han åpner øynene. Han sier med
                            svak stemme: <i>«Jeg er så glad i dere»</i>. Beate visste da at mannen
                            hennes var tilbake. All frykten forsvant umiddelbart.
                        </Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Jeg tenkte at han må ha hørt oss de siste dagene. Alle de dårlige
                            historiene, latteren og galgenhumoren, for det er ikke ord han bruker
                            veldig ofte. Han viser at han er glad i oss mer enn at han sier det med
                            ord, smiler hun.
                        </Quote>
                        <Paragraph color="all-white">
                            Etter to uker blir han flyttet fra UNN i Tromsø til Nordlandssykehuset i
                            Bodø, som de tilhører. Der ligger Tor-Arne i 14 nye dager hvor han får
                            tett oppfølging. Det blir avklart at han fortsatt har en del
                            hjerteflimmer. Derfor får han tilbud om å få en ICD, en kombinert
                            hjertestarter og pacemaker satt inn. Det takker han ja til.
                        </Paragraph>
                        <Paragraph color="all-white">
                            Dagen etter blir Tor-Arne skrevet ut.
                        </Paragraph>
                        <Heading type="h3" weight="600" color="all-white">
                            Ville tilbake i arbeid
                        </Heading>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Arbeidet mitt har alltid vært mer enn 50% av livet mitt. Så et av de
                            første spørsmålene jeg hadde var når jeg kunne starte igjen.
                        </Quote>
                        <Paragraph color="all-white">
                            Han er ivrig på å komme i gang med opptreningen, og får beskjed om at
                            han må se an et års tid før de skal ta en ny vurdering.
                        </Paragraph>
                        <Paragraph color="all-white">
                            Tor-Arne beskriver seg selv som sta. Allerede samme dagen som de kommer
                            hjem går Tor-Arne og Beate 160 meter til postkassen og tilbake. Da er
                            han utslitt. Men de utvider avstanden sakte, men sikkert. Etter to
                            måneder er han tilbake i jobb 20%.
                        </Paragraph>
                        <Image
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/12/torarne-3.jpg"
                            alt=""
                            caption="<b>Opptatt av helsen:</b> Etter hendelsen blir Tor-Arne veldig opptatt av å ta vare på seg selv. Sammen med Beate går han mange turer og trener jevnlig i styrkerommet deres."
                            captionColor="all-white"
                        />
                        <Paragraph></Paragraph>
                        <Heading type="h3" weight="600" color="all-white">
                            Ny hjertestans
                        </Heading>
                        <Paragraph color="all-white">
                            Etter hendelsen blir Tor-Arne veldig opptatt av å ta vare på seg selv.
                            De har treningsrom i kjelleren så han går mye på mølla, mens Beate
                            trener styrke. En dag bestemmer han seg for å jogge. Plutselig faller
                            han mot Beate. Hun klarer heldigvis å ta han imot og legge han på gulvet
                            mens han roper voldsomt.
                        </Paragraph>
                        <Paragraph color="all-white">
                            Han får en ny hjertestans, men pacemakeren slår inn. Tor-Arne åpner opp
                            øynene.
                        </Paragraph>
                        <Paragraph color="all-white">
                            Beate spør: <i>«Hvordan føler du deg?»</i>
                        </Paragraph>
                        <Paragraph color="all-white">
                            Tor-Arne svarer: <i>«Helt fin!»</i>
                        </Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Han ville fortsette dagen sin, og han ville i hvert fall ikke til
                            legevakten, men vi dro inn etter hvert, bare for sikkerhetsskyld, ler
                            Beate.
                        </Quote>
                        <Paragraph color="all-white">Tor-Arne legger til: </Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Jeg fikk beskjed om at jeg ikke trenger å løpe. Det holder å gå,
                            smiler han.
                        </Quote>
                        <Paragraph color="all-white">I dag føler han seg i god form.</Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Jeg er jo så heldig at jeg har tryggheten i pacemakeren. Hvis noe
                            skjer, så har jeg den.
                        </Quote>

                        <Image
                            src="https://norskluftambulanse.no/wp-content/uploads/2024/12/torarne-2.jpg"
                            alt=""
                            caption="<b>Nyter hverdagen:</b> I dag er Tor-Arne tilbake 100%. Han nyter hverdagene med Beate, og er tilbake i full jobb – som han trives veldig med."
                            captionColor="all-white"
                        />
                        <Paragraph></Paragraph>
                        <Heading type="h3" weight="600" color="all-white">
                            Besøkte luftambulansemannskapet
                        </Heading>
                        <Paragraph color="all-white">
                            I etterkant har de vært på besøk hos luftambulansebasen, for å takke.
                        </Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – Vi hadde et voldsomt behov for å få treffe ambulansepersonellet,
                            luftambulansemannskapet, og de på sykehuset, for å få takke dem. Vi
                            føler oss så vanvittig heldige som har fått livet tilbake, sier
                            Tor-Arne.
                        </Quote>
                        <Paragraph color="all-white">
                            De hadde en lang og god samtale med luftambulansemannskapet om
                            hendelsen, men også hvordan det var for Beate som pårørende.
                        </Paragraph>
                        <Quote animation="fade-up" color="primary-white" borderColor="red">
                            – I etterkant var utrolig godt å få snakke med dem som reddet livet til
                            Tor-Arne. Jeg tror det er kjempeviktig å prate om hendelsen, både for
                            dem som har opplevd det som pårørende og som pasient, men kanskje også
                            for de som jobber i de forskjellige nødetatene. Det er takket være
                            innsatsen deres at han er 100% tilbake, smiler hun.
                        </Quote>

                        <FooterCTA
                            href="/nettbutikk/symbolske-gaver/et-hjerte-som-banker-igjen/"
                            linkText="<b>Et hjerte som banker igjen</b><br/>Kjøp den symbolske gaven her"
                            color="red"
                            bgColor="off-white"
                            textColor="all-white"
                            target="_blank"
                        />
                    </Content>
                </Section>

                <Section color="off-white">
                    <Content width="large">
                        <Divider
                            color="secondary"
                            title="Støtt Stiftelsen Norsk Luftambulanse for en tryggere fremtid"
                        />
                        <SplitCTABox color="secondary" />
                        <VippsBanner />
                    </Content>
                </Section>

                <Section color="off-white">
                    <Content width="large">
                        <CTABlock
                            anchor="hjelp-113"
                            divider
                            color="secondary"
                            title="Det koster ingenting å være bedre forberedt"
                            innerTitle="Last ned Hjelp 113-appen"
                            appleGoogleStore
                            orientation="left"
                            imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/09/hjelp-113-cta-bottom.jpg"
                            alt="Utviklingshelikopteret på øvelse"
                            bulletPoints={[
                                'Alle nødnumre på ett sted (110, 112 og 113)',
                                'Andre viktige numre som nærmeste legevakt og mental helse hjelpetelefon',
                                'Koordinatene der du befinner deg',
                                'Oversikt over hjertestartere i nærheten',
                                'Appen er gratis og har nå 2,6 millioner nedlastninger'
                            ]}
                        />
                    </Content>
                </Section>
            </div>
        </div>
    );
};

export default TorArne;
